import { loggerFactory } from 'ert-logger';
import { headerScriptDomId, PubSubMessages } from '../config';
import { publish } from 'ert-framebus';
import { AuthData } from 'navigator-header';

const logger = loggerFactory.createLogger('Global Header/header-script.ts');

const thisScript = (document.getElementById(headerScriptDomId) || document.currentScript) as HTMLScriptElement;

const clientIdAttribute = 'data-client-id';

let src: string;
export let clientId: string;

if (thisScript) {
    src = thisScript.getAttribute('src');
    clientId = thisScript.getAttribute(clientIdAttribute) || '';

    if (clientId) {
        try {
            const authData: AuthData = JSON.parse(localStorage.getItem(`${clientId}_global_header_auth`));

            publish(PubSubMessages.idTokenData, authData.idToken, 'localStorage');
        } catch (e) {
            logger.error(e);
        }
    }

    // logging of unhandled errors
    const prev = window.onerror;
    // tslint:disable-next-line:no-function-expression
    window.onerror = function (messageOrEvent, url, lineNo, columnNo, error) {
        const args = arguments;
        const done = () => {
            if (prev && typeof prev === 'function') {
                return prev.apply(prev, args);
            }
        };
        if (url !== src) {
            return done();
        }
        const message = [
            `Message: ${messageOrEvent}`,
            `URL: ${url}`,
            `Line: ${lineNo}`,
            `Column: ${columnNo}`
        ].join(' - ');
        logger.error(message, error);
        return done();
    };
}

publish(PubSubMessages.scriptData, src, clientId);
